<template>
  <div id="on-boarding-contents-frame"  class="w-full flex justify-between justify-center flex-direction--column" >
    <div style="min-height: 420px; height: 100%;">

      <div class="w-full h-full flex justify-between justify-center flex-direction--column" >
        <div class="flex w-full justify-center items-center"  style="height: 60px;">
          <div class="aisea-text-34-400-blue" >[{{ contentsPageMap[activeContents][activePageMap[activeContents]].title }}]</div>
        </div>
        <div class="w-full h-full" style="overflow-y: auto;" >

          <!-- 各ページ要素は OnboardingContentsItems に記述 -->
          <onboarding-contents-items 
            :activeContents="activeContents"
            :activePageMap="activePageMap"
            @setPage="setPage"
          />

        </div>
        <div v-if="activeContents !== 4" class="flex w-full justify-between items-center px-4" style="max-height: 60px;">
          <div @click="prevPage" class="flex ustify-start items-center cursor-pointer">
            <div class="aisea-text-34-400-blue mr-2"  :class="[ {'page-button-disabled' : !canPrevPage}, ]">
              <span class="material-icons">arrow_circle_left</span>
            </div>
            <div class="aisea-text-16-400-blue" :class="[ {'page-button-disabled' : !canPrevPage}, ]">戻る</div>
          </div>
          <div class="flex w-1/2 justify-center items-center">
            <div v-for="pageKey in Object.keys(contentsPageMap[activeContents])" :key="pageKey">
              <div @click="activePageMap[activeContents] = Number(pageKey)" class="page-index-circle  cursor-pointer" :class="[ {'selected-page' : (activePageMap[activeContents] === Number(pageKey) )} ]" />
            </div>

          </div>
          <div @click="nextPage" class="flex justify-end items-center cursor-pointer">
            <div class="aisea-text-16-400-blue" :class="[ {'page-button-disabled' : !canNextPage}, ]">次へ</div>
            <div class="aisea-text-34-400-blue ml-2">
              <span class="material-icons" :class="[ {'page-button-disabled' : !canNextPage}, ]">arrow_circle_right</span>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="flex w-full" style="height: 60px; background-color: white; border-radius: 0 0 6px 6px;">
      <div v-for="pageKey in Object.keys(contentsTabMap)" :key="pageKey" :style="{ width: `${ 100 / Object.keys(contentsTabMap).length }%`, }">
        <div 
          @click="activeContents = Number(pageKey)" :class="[ {'selected-tab' : (activeContents === Number(pageKey))} ]"
          class="flex w-full h-full justify-center items-center cursor-pointer" 
          :style="{ 'border-radius': pageKey === '1' ? '0 0 0 6px' : pageKey === String(Object.keys(contentsTabMap).length) ? '0 0 6px 0' : null }"
        >
          <div class="mr-2 flex justify-center items-center contents-index-circle" >{{ pageKey }}</div>
          {{ contentsTabMap[pageKey] }}
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import OnboardingContentsItems from "./components/OnboardingContentsItems";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  name: "OnboardingContentsFrame",
  components: {
    OnboardingContentsItems,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      activeContents: 1,
      activePageMap:{
        1: 1,
        2: 1,
        3: 1,
        4: 1,
      },
      contentsTabMap: {
        1: 'サービス概要',
        2: '初期設定', 
        3: '運用', 
        4: 'マニュアル', 
      },
      contentsPageMap: {
        1: {
          1: { title: 'サービス概要', },
          2: { title: 'アプリでの打刻', },
          3: { title: 'アプリでの承認', },
          4: { title: 'Webでアラート発生有無確認', },
          5: { title: 'Webで労務管理記録簿の確認', },
        },
        2: {
          1: { title: '初期設定の方法', },
          2: { title: '労務基本情報の登録', },
          3: { title: '船舶の登録', },
          4: { title: '陸上従業員のWebアカウント発行', },
          5: { title: '船員の登録', },
          6: { title: '各船員ページへの遷移', },
          7: { title: '労務情報の登録', },
          8: { title: '乗船期間の登録', },
          9: { title: '船員のアプリアカウント発行', },
        },
        3: {
          1: { title: '運用時の利用方法', },
          2: { title: '過労アラート発生有無の確認', },
          3: { title: '労務管理記録簿の確認', },
          4: { title: '打刻記録の確認、差戻し', },
          5: { title: '乗船期間の更新', },
        },
        4: {
          1: { title: '詳細マニュアル', },
        },

      },
    };
  },
  created() {
  },
  computed: {
    canPrevPage() {
      return this.activePageMap[this.activeContents] > 1;
    },
    canNextPage() {
      return this.activePageMap[this.activeContents] < Object.keys(this.contentsPageMap[this.activeContents]).length ;
    },
  },
  methods: {
    prevPage() {
      if ( this.canPrevPage ) {
        this.activePageMap[this.activeContents] = this.activePageMap[this.activeContents] - 1;
      }
    },
    nextPage() {
      if ( this.canNextPage ) {
        this.activePageMap[this.activeContents] = this.activePageMap[this.activeContents] + 1;
      }
    },
    setPage(val) {
      this.activeContents = Number(val.contentsNum);
      this.activePageMap[Number(val.contentsNum)] = Number(val.pageNum); 
    },
  },  
};
</script>


<style lang="scss">
@import "src/assets/scss/aisea/variables";

#on-boarding-contents-frame {
  height: calc(100vh - 114px );

  .contents-index-circle {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    background-color: $aisea-light-blue;
    color: $aisea-white;
  }
  .selected-tab {
    background-color: rgba($aisea-light-blue, 0.4);
    border-top: 4px solid $aisea-blue;

    .contents-index-circle {
      background-color: $aisea-blue;
    }

  }


  .page-index-circle {
    margin: 0 0.8rem;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background-color: $aisea-light-gray;
  }
  .selected-page {
    background-color: $aisea-blue;
  }

  .page-button-disabled {
    color: $aisea-slightly-gray;
  }

}

</style>
